module.exports = __webpack_public_path__ + "img/pd-img3.c633dfc9.png";